export default {
    styleOverrides: {
        root: () => ({
            display: "flex",
            alignItems: "center",
        }),
    },
};
